<template>
  <div>
    <!-- <base-card :option="cardOption">
      <div slot="cardBody"> -->
    <search-form @setSearchCondition="setSearchCondition" @clearSearch="clearSearch"></search-form>
    <!--      操作按钮-->
    <div class="table-operator">
      <a-button type="primary" v-action:saveSales icon="plus" @click="handleAdd" style="margin-right:10px">新增</a-button>
      <a-popconfirm
        title="确定要批量删除吗?"
        @confirm="batchDel">
        <a-button v-action:deleteSales icon="delete">批量删除</a-button>
      </a-popconfirm>
    </div>
    <!--表格-->
    <a-table
      :columns="table.columns"
      :rowKey="record => record.id"
      :dataSource="table.data"
      :pagination="pagination"
      :loading="table.loading"
      @change="handleTableChange"
      :rowSelection="rowSelection"
      :scroll="{ x: 2080 }"
    >
      <!--filterDropdown-->
      <div
        slot="filterDropdown"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        style="padding: 8px"
      >
        <a-input
          v-ant-ref="c => searchInput = c"
          :placeholder="`请输入${column.title}`"
          :value="selectedKeys[0]"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, confirm)"
          style="width: 188px; margin-bottom: 8px; display: block;"
        />
        <a-button
          type="primary"
          @click="() => handleSearch(selectedKeys, confirm)"
          icon="search"
          size="small"
          style="width: 90px; margin-right: 8px"
        >搜索
        </a-button
        >
        <a-button
          ref="clearBtn"
          @click="() => handleReset(clearFilters)"
          size="small"
          style="width: 90px"
        >重置
        </a-button
        >
      </div>
      <a-icon
        slot="filterIcon"
        slot-scope="filtered"
        type="search"
        :style="{ color: filtered ? '#108ee9' : undefined }"
      />
      <span slot="roles" slot-scope="roles">
        <a-tag v-for="(role,index) in roles" :key="index">
          {{ role.label }}
        </a-tag>
      </span>
      <span slot="status" slot-scope="text,record">
        <a-tag v-if="record.status===1" :color="record.status ===1 ? 'green' : 'volcano'">
          正常
        </a-tag>
        <a-tag v-if="record.status===2" :color="record.status ===1 ? 'green' : 'volcano'">
          异常
        </a-tag>
      </span>
      <template slot="actions" slot-scope="text, record">
        <a href="javascript:;" @click="()=>handleView(record)">查看</a>
        <template v-if="$auth('contract.updateSales')">
          <a-divider type="vertical"/>
          <a href="javascript:;" @click="()=>handleEdit(record)">编辑</a>
        </template>
        <template v-if="$auth('contract.deleteSales')">
          <a-divider type="vertical"/>
          <a-popconfirm
            title="确定要删除吗?"
            @confirm="() => onDelete(record)"
          >
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>

        <!-- <a-divider type="vertical"></a-divider> -->
        <!-- <a-dropdown>
          <a class="ant-dropdown-link" href="#"> 更多
            <a-icon type="down"/>
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a href="javascript:;" @click="setFollow(record)">市场跟踪</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" v-action:update @click="changPerson(record)">变更负责人</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown> -->
      </template>

    </a-table>
    <!-- </div>
    </base-card> -->
    <!--各种弹出组件-->
    <edit-modal ref="editModal" @refreshTable="initTableData"></edit-modal>
    <view-modal ref="viewModal"></view-modal>
  </div>
</template>

<script>
import { getSalesContractList, deleteContract } from '@/api/contract'
import editModal from './modules/editModal'
import viewModal from './modules/viewModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'

export default {
  name: 'MarketsList',
  mounted () {
    this.searchModel = { ...this.pagination }
    this.initTableData()
    // this.initData()
  },
  computed: {},
  components: {
    editModal,
    searchForm,
    baseCard,
    viewModal
  },
  data () {
    return {

      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true
      },
      table: {
        data: [],
        columns: [
          {
            title: '序号',
            customRender: (text, record, index) => `${index + 1}`,
            width: 80
          },
          {
            title: '合同编号',
            dataIndex: 'number',
            width: 160
          },
          {
            title: '合同名称',
            dataIndex: 'name'
            // width: 220
          },
          {
            title: '项目简称',
            dataIndex: 'projectShortName',
            width: 220
          },
          {
            title: '招标单位',
            dataIndex: 'proprietorName',
            width: 220
          },
          {
            title: '生效日期',
            dataIndex: 'effectiveDate',
            width: 160
          },
          {
            title: '合同金额',
            dataIndex: 'contractAmount',
            width: 140
          },
          {
            title: '已开票金额',
            dataIndex: 'invoicedAmount',
            width: 140
          },
          {
            title: '已收金额',
            dataIndex: 'amountReceived',
            width: 140
          },
          {
            title: '已收比例',
            dataIndex: 'receivedProportion',
            width: 120,
            customRender: (text) => {
              if (text || text === 0) {
                return text + '%'
              }
            }
          },
          {
            title: '未收金额',
            dataIndex: 'outstandingAmount',
            width: 140
          },
          {
            title: '经办人',
            dataIndex: 'operatorName',
            width: 140
          },
          {
            title: '操作',
            width: 160,
            fixed: 'right',
            scopedSlots: { customRender: 'actions' }
          }
        ],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    // 搜索
    setSearchCondition (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.searchModel = { ...this.pagination, ...this.searchTableModel, ...searchFormModel }
      this.initTableData()
    },
    // 重置
    clearSearch (searchFormModel) {
      this.searchFormModel = searchFormModel
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = { ...this.pagination, ...this.searchTableModel }
      this.table.filteredInfo = null
      this.table.sortedInfo = null
      delete this.searchModel.sortField
      delete this.searchModel.sortOrder
      this.initTableData()
    },
    // 表格中的搜索
    handleSearch (selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },
    // 表格中的重置
    handleReset (clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 初始化表格数据
    initTableData () {
      this.table.loading = true
      getSalesContractList(this.searchModel).then(res => {
        if (res.status === 0) {
          this.table.loading = false
          this.table.data = res.data.list
          this.pagination.total = res.data.total
        } else {
          this.$message.error('获取数据失败！')
        }
      })
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.table.filteredInfo = filters
      this.table.sortedInfo = sorter
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.current
      this.pagination.current = pagination.current
      this.searchModel = {
        ...this.searchFormModel,
        ...this.pagination,
        ...this.searchTableModel,
        sortField: sorter.field,
        sortOrder: sorter.order
      }
      this.initTableData()
    },
    // 删除操作
    onDelete (model) {
      deleteContract(model.id).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 查看详情
    handleView (model) {
      this.$refs.viewModal.setTitle('查看销售合同信息')
      this.$refs.viewModal.setType(this.$sysInfo.MODAL_VIEW)
      this.$refs.viewModal.setModel(model) // 先设置类型，再打开
      this.$refs.viewModal.open(true)
    },
    // 编辑
    handleEdit (model) {
      this.$refs.editModal.setTitle('编辑销售合同信息')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_MODIFY)
      this.$refs.editModal.setModel(model)// 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 新增
    handleAdd () {
      this.$refs.editModal.setTitle('新增销售合同')
      this.$refs.editModal.setType(this.$sysInfo.MODAL_ADD)// 先设置类型，再打开
      this.$refs.editModal.open(true)
    },
    // 批量删除
    batchDel () {
      const searchModel = this.selectedRows
      if (!searchModel || searchModel.length === 0) {
        this.$message.error('请至少选择一行数据进行删除！')
        return
      }
      let params = ''
      searchModel.map(item => {
        params += item.id + ','
      })
      params = params.substring(0, params.length - 1)
      deleteContract(params).then(res => {
        if (res.status === 0) {
          this.$message.success(res.info.message)
          this.initTableData()
        } else {
          this.$message.error(res.info.message)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
